// extracted by mini-css-extract-plugin
module.exports = {"ibsvt7h":"ibsvt7h","sp-code-editor":"sp-code-editor","r1w674po":"r1w674po","r14pemjt":"r14pemjt","r1lwkt8c":"r1lwkt8c","cvykehj":"cvykehj","ps80g1r":"ps80g1r","cgb9yb1":"cgb9yb1"};